import React, { useEffect, useReducer} from 'react';
import {Container, Row, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import $ from 'jquery'
import Subfooter from './Subfooter';

const HomePage = () => {
    useEffect(() =>{
        document.title = "Home | Rich-Oak Group"
    },[])


      $(document).ready(function(){
        $(".inner1").hover(function(){
          $(this).css("background-color", "#D80032");
          $(".changehead1").css("color", "#FFF");
          $(".changebody1").css("color", "#FFF");
          }
          , function(){
          $(this).css("background-color", "#00000005");
          $(".changehead1").css("color", "#000");
          $(".changebody1").css("color", "#3E3E3E");
        }
        
        );

        $(".inner2").hover(function(){
            $(this).css("background-color", "#D80032");
            $(".changehead2").css("color", "#FFF");
            $(".changebody2").css("color", "#FFF");
            }
            , function(){
            $(this).css("background-color", "#00000005");
            $(".changehead2").css("color", "#000");
            $(".changebody2").css("color", "#3E3E3E");
          }
          
          );

          $(".inner3").hover(function(){
            $(this).css("background-color", "#D80032");
            $(".changehead3").css("color", "#FFF");
            $(".changebody3").css("color", "#FFF");
            }
            , function(){
            $(this).css("background-color", "#00000005");
            $(".changehead3").css("color", "#000");
            $(".changebody3").css("color", "#3E3E3E");
          }
          
          );
      });

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="hmfirstbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Investments built on <br/><span style={{color:"#D80032"}}>Trust</span> and <span style={{color:"#D80032"}}>Transparency</span></h3>
        <p className='description hmfirstboxdescription'>We are building long-term relationships with our clients, partnering with<br/>
        individuals and institutions to achieve long term financial growth.</p>
        
        <p class="centermobile">
        <button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button>
        <a target="_blank" href="/ourpeople">
        <h4 className="hmbuttons hmvot">
            View our team
         <img src="images/arrow_forward.png"/>
         </h4>
        </a>
     
        </p>

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox'>
    {/* <div className='hmsecondinnerbox'>

        <Container>
            <Row>
                <div className='col-md-2 col-6'>
                <img className=""  style={{height:"32px",width:"100px"}} src="images/partners/remita.png"/>
                    </div>

                    <div className='col-md-2 col-6'>
                <img className="" style={{height:"32px",width:"100px"}} src="images/partners/remita.png"/>

                    </div>

                    <div className='col-md-2 col-6'>
                <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>
                    </div>

                    <div className='col-md-2 col-6'>
                <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>

                    </div>

                    <div className='col-md-2 col-6'>
                    <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>
                    </div>

                    <div className='col-md-2 col-6'>
                    <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>
                    </div>
                
            </Row>
        </Container>
        </div> */}
    </div>


    <div className='hmthirdbox'>
    <div className=''>
        {/* <Container> */}
            <Row>
                <div className='col-lg-6 col-md-12'>
                <img class="blogmobile" style={{width:"100%"}} src="images/peoplebg.jpg"/> 
                {/* <iframe className="img-fluid" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
                    </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-lg-6 col-md-12'>
                    <h1 className="hmwwd">Who are<span style={{color:"#D80032"}}> we </span>?</h1>
                    {/* <hr class="hpwwdhr1"/> */}
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, 
                        innovation and providing premium value. Our vision is to be Africa's most reliable financial partner. 
                        We invest capital on behalf of individuals and institutions across the alternative asset classes in real estate, 
                        credit and agriculture, increasing the wealth of our investors.
                         Our businesses are impact driven, providing support to various industries and sectors.</p>
                    </div>

                    {/* <div className='col-md-5 formobileonly'>
                <iframe className="img-fluid hmytvideo" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> */}

               
                
            </Row>
        {/* </Container> */}
        </div>
    </div>

    <div className='hmtenthbox'>
        <Row>
            <div className='col-md-12'>
            <p className="whatwedohead">What <span style={{color:"#D80032"}}>We</span> do</p>
           <hr class="whatwedohr"/>
            <p className="whatwedobody">We invest on behalf of private individuals and institutions across different alternative <br/>investment asset classes in order to achieve thier investment goals</p>
            </div>
        </Row>
      
    </div>

    <div className='hmlastbox'>
  
        <Row>

        <div className='col-lg-4 col-md-6'>
            

            <div className="hmlastboxinner inner1">
            <img src="images/security.png"/> 
                        <p className="whatwedolastboxhead changehead1">Security  of investors funds</p>
                        <p  className="whatwedolastboxbody changebody1">Security of investors funds remain our primary goal and this guides our approach to investing. 
                            We invest in sound business opportunities where we can gain long term competitive 
                            advantage which will in turn provide higher returns and diversification benefits.</p>
                        {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            
                        </div>
                        </div>
            
                        <div className='col-lg-4 col-md-6'>
                        {/* <img style={{width:"100%"}}  src="images/wwd2.png"/>  */}
                        <div className="hmlastboxinner inner2">
                        <img src="images/diversified.png"/> 
                        <p className="whatwedolastboxhead changehead2">Diversified Investments </p>
                        <p className="whatwedolastboxbody changebody2">
                        Security of investors funds remain our primary goal and this guides our approach to investing. We invest in sound business opportunities where we can gain long term competitive advantage which will in turn provide higher returns and diversification benefits.
                             </p>
                             {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            </div>
                        </div>
            
                        <div className='col-lg-4 col-md-12 inner3'>
                        {/* <img style={{width:"100%"}}  src="images/wwd2.png"/>  */}
                        <div className="hmlastboxinner">
                        <img src="images/continous.png"/> 
                        <p className="whatwedolastboxhead changehead3">Continous Innovation </p>
                        <p className="whatwedolastboxbody changebody3">
                        We are aware that the business and financial landscape is constantly changing. In all our 
                        businesses either existing or new, we are constantly on the look out for opportunities and innovating on behalf of our customers to fill the gap of those opportunities. 
                        </p>
                             {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            </div>
                        </div>
                        <Row/>




                        <Row>
            <div className='col-md-12'>
            <p className="whatwedohead">Current Investment Allocation </p>
           <hr class="whatwedohr"/>
            <p className="whatwedobody">We invest on behalf of private individuals and institutions across different alternative <br/>investment asset classes in order to achieve thier investment goals</p>
            </div>
        </Row>
     
     <div class="row realestatebox">
                <div className='col-md-6 hideipad'>
                <img class="img-fluids"  src="images/realestate.jpg"/> 
                    </div>


                    <div className='col-lg-6 col-md-12 realestate3'>
                    <h1 className="hmwwd realestatehead">Real estate</h1>
               
                    <p className='hmsecondboxdescription'>
                        
                    The Real Estate Investment Fund is an Investment vehicle powered by Rich-Oak that allows Interested Investors hold a portion of prime real estate assets without needing to come up with the entire purchase amount while enjoying the returns & benefits of real estate. This is in line with our goal of becoming the leading providers of alternative investment solutions in Africa.                         
                         </p>
                         <p class="centermobile">
                         <Link target="_blank" to="/realestate"><button className='hmfirstboxbuttonrealestate hmbuttons'>LEARN MORE</button></Link>
                             </p>

                    </div>
</div>

              <div class="row realestatebox2">       

              <div className='col-md-6 hideipad formobileonly'>
                <img class="img-fluids hideipad"   src="images/credit.png"/> 
                    </div>
                    <div className='col-lg-6 col-md-12 realestate3'>
                    <h3 className="hmwwd realestatehead">Credit</h3>
               
                    <p className='hmsecondboxdescription'>
                        
                    We focus on providing support to individuals and businesses in Nigeria. Through our diverse range of loan products, we help people fulfill their goals, meet urgent cash needs, take advantage of opportunities, and enable businesses to prosper.

For us, serving our customers is about striving to be with you every step of the way in meeting your needs. One of the ways to ensure this is by constantly offering our loan customers a competitive interest rate.

Wherever you are in life, we are a long term financial partner you can count on; our loan products are designed specially for you and your unique needs                         </p>
                         <p class="centermobile">
                         <Link to="/credit" target="_blank"> <button className='hmfirstboxbuttonrealestate2 hmbuttons'>LEARN MORE</button></Link>
</p>
                    </div>

                    <div className='col-md-6 fordesktoponly'>
                <img class="img-fluids hideipad" src="images/credit.png"/> 
                    </div>
                    </div>

                    {/* <div class="row realestatebox2">     
                    <div className='col-md-6 hideipad'>
                <img class="img-fluids hideipad"   src="images/agric.png"/> 
                    </div>


                    <div className='col-lg-6 col-md-12 realestate3'>
                    <h1 className="hmwwd realestatehead">Agriculture</h1>
               
                    <p className='hmsecondboxdescription'>
                        
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus odio fermentum ornare nulla condimentum eget. Fermentum, aliquet bibendum nec sed aliquam urna in. Et, porttitor et sollicitudin cras tellus, placerat risus elit morbi. Faucibus tincidunt nibh vel, eu. Ornare egestas orci amet, ipsum. Laoreet quam purus vivamus viverra ullamcorper vulputate nullam.
                         </p>
                         <p class="centermobile">
                         <button className='hmfirstboxbuttonrealestate2 hmbuttons'>LEARN MORE</button>
</p>
                    </div>
                    </div> */}

              
               
                
            </Row>


          

      
    </div>



    <div className='hmfifthbox'>
    <div className=''>
            <Row>
                <div className='col-lg-6 col-md-12'>
                <div class="divinvestments">
                        <p className="hmciahead">Our Investment Impact</p>
                        <p  className='hmfourthboxinner'>
                        We are strengthening  Africa by building value driven partnerships and increasing the wealth of individuals and institutions. 
                            </p>
                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Why Investors Trust us </p>
                        <p  className='hmfourthboxinner'>
                        With security of funds as our top priority, we carefully carry out risk evaluations which involve, risk identification, impact assessment and developing strategies to mitigate against such risks. Our success hinges on exceeding our customers expectations and helping them grow their wealth. We have done this over the years by keeping our word and paying investors consistently.               
                            </p>
                            </div>
                    </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-lg-5 col-md-12'>
                    <p className="hmciahead">Frequently Asked Questions</p>
                    <p  className='hmfourthboxinner'>
                    We are always available to help you with any of your enquiries, requests and complaints.
We provide various channels to ensure you contact us.
                            </p>

                            <Accordion style={{marginTop:"60px"}}>
  <Accordion.Item eventKey="0">
    <Accordion.Header className="faqqheader">Who are we ? 

</Accordion.Header>
    <Accordion.Body>
    Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, innovation and providing premium value.
salary earners, and visa applicants.


    </Accordion.Body>
  </Accordion.Item>

  {/* <Accordion.Item eventKey="1">
    <Accordion.Header className="faqqheader">What are we?

</Accordion.Header>
    <Accordion.Body>
    Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, innovation and providing premium value.

    </Accordion.Body>
  </Accordion.Item> */}

  {/* <Accordion.Item eventKey="2">
    <Accordion.Header className="faqqheader">Are loans only open to business owners alone?
</Accordion.Header>
    <Accordion.Body>
    Small businesses, salary earners, medium enterprises, large ventures that meet the criteria for a loan are also to access financing from CREDISOL.

    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="3">
    <Accordion.Header className="faqqheader">How much is the interest rate:
</Accordion.Header>
    <Accordion.Body>
    5% on travel loans and 6-10% on business depending on the type of business.

    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="4">
    <Accordion.Header className="faqqheader">Do you finance visa application?
</Accordion.Header>
    <Accordion.Body>
    No, we don’t we only help finance proof of funds in the individual or corporate account.

    </Accordion.Body>
  </Accordion.Item> */}

  {/* <Accordion.Item eventKey="5">
    <Accordion.Header className="faqqheader">How can I schedule a site Inspection?

</Accordion.Header>
    <Accordion.Body>
    You can schedule a site Inspection by filling this form here 


    </Accordion.Body>
  </Accordion.Item>


  <Accordion.Item eventKey="6">
    <Accordion.Header className="faqqheader">Who can I speak to for further assistance?


</Accordion.Header>
    <Accordion.Body>
    You can call us on 09016854815 or send an email to info@earthvii.org



    </Accordion.Body>
  </Accordion.Item> */}


</Accordion>
                    </div>     

                   
            </Row>
        </div>
    </div>


<Subfooter/>
    </div>







    <Footer/>
    </div>


    )
    
    
}


export {HomePage as default}